import React, { useEffect, useRef } from 'react';
import './Leaderboard.css';

const Leaderboard = ({ leaderboard = [], userId, isTimeBased = false }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    // Animation d'entrée lors du chargement du composant
    if (containerRef.current) {
      containerRef.current.classList.add('show');
    }
    
    // Animation pour chaque entrée
    const items = document.querySelectorAll('.leaderboard-item');
    items.forEach((item, index) => {
      setTimeout(() => {
        item.classList.add('show');
      }, 100 * index);
    });
  }, [leaderboard]);

  // Obtenez le classement par médaille pour les trois premiers
  const getMedalClass = (index) => {
    switch (index) {
      case 0: return 'gold-medal';
      case 1: return 'silver-medal';
      case 2: return 'bronze-medal';
      default: return '';
    }
  };

  // Formater le score selon le type (temps ou points)
  const formatScore = (score) => {
    if (isTimeBased) {
      const minutes = Math.floor(score / 60);
      const secs = Math.floor(score % 60);
      const ms = Math.round((score % 1) * 1000).toString().padStart(3, '0');
      return `${minutes}:${secs.toString().padStart(2, '0')}.${ms}`;
    }
    return score; // Afficher les points directement pour Quizz
  };

  // Générer des particules décoratives pour les 3 premiers rangs
  const renderParticles = () => {
    return Array(15).fill().map((_, i) => (
      <div key={`particle-${i}`} className="particle"></div>
    ));
  };

  // Limiter à 10 scores maximum
  const topTenLeaderboard = leaderboard.slice(0, 10);

  return (
    <div ref={containerRef} className="leaderboard-container">
      <div className="leaderboard-glow"></div>
      <h3 className="leaderboard-title">Mur de la renommée</h3>
      
      {topTenLeaderboard.length > 0 ? (
        <ul className="leaderboard-list">
          {topTenLeaderboard.map((entry, index) => (
            <li 
              key={entry.userId || index} 
              className={`leaderboard-item ${entry.userId === userId ? 'current-user' : ''} ${getMedalClass(index)}`}
            >
              <div className="rank-container">
                {index < 3 && <div className="medal-effect"></div>}
                <span className="rank">{index + 1}.</span>
              </div>
              
              <span className="pseudo">{entry.pseudo}</span> {/* Utilisation uniquement du pseudo */}
              
              <div className="score-container">
                <span className="score">{formatScore(entry.score)}</span> {/* Formatage selon isTimeBased */}
                {index < 3 && renderParticles()}
              </div>
              
              {/* Effet de surlignage */}
              <div className="highlight-effect"></div>
            </li>
          ))}
        </ul>
      ) : (
        <p className="no-scores">Aucun score disponible.</p>
      )}
    </div>
  );
};

export default Leaderboard;